import React from 'react'
import SALink from 'components/SALink'
import { OwnerAvatar } from 'styles/algolia/user/header'
import TriangleLeft from 'svg/triangle-left.svg'
import HeaderConnector, { ConnectorProps as HeaderProps } from '../../connectors/Header'
import Actions from './Actions'
import { InfoRow, InfoColumn, ArtistName, BackToProfile, OwnerInfoSection } from './styles'
import { capitalizeString } from 'lib/helpers'

export default HeaderConnector((props: HeaderProps) => {
  const { avatarUrl, artistName, artistId } = props
  const capitalizedArtistName = capitalizeString(artistName)

  return (
    <OwnerInfoSection>
      <InfoRow data-type='accountArt'>
        <SALink
          href={`/account/profile/${artistId}`}
          title={`View profile of ${capitalizedArtistName}`}
        >
          <OwnerAvatar src={avatarUrl} alt={capitalizedArtistName} />
        </SALink>
        <InfoColumn>
          <ArtistName>{capitalizedArtistName}'s Art Collections</ArtistName>
          <BackToProfile href={`/account/profile/${artistId}`}>
            <TriangleLeft />
            Back to profile
          </BackToProfile>
        </InfoColumn>
        <Actions />
      </InfoRow>
    </OwnerInfoSection>
  )
})
